import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import store from 'store';
import { addInitConversationInAttendance } from 'store/action/conversation-in-attendance-action';
import { apiChat } from '../../../../http';
import { TabContent } from 'reactstrap';
import { Content, Header } from './components/styled';
import { toast } from 'react-toastify';
import { useConversationConnectionSocketForMonitoring } from 'hooks/useConversationConnectionSocketForMonitoring';
import { useSocketEvents } from 'hooks/socket-utils';
import {
  EVENTS_EMIT,
  useSocketConversationChatTs
} from '../../../../hooks/useSocketConversationChatTs';
import { checkAndLogout } from '../../../../store/action/auth';

//react virtualized
import 'react-virtualized/styles.css';
import TagClientService from 'views/CRM/Tags/services/TagClientService';

import { useHistory } from 'react-router-dom';
import { useQueueChatPauseContext } from '../../../../hooks/useQueuePauseChatServicePanel';
import { ChatSituations } from '../../../../utils/fuctions/mapSituationChat';
import { FilterBar } from './components/FiltersBar';
import { SearchChat } from './components/searchChats';
import { TabChats } from './components/Tabs';
import { IndividualActiveContact } from './components/ActiveContact';
import { TabAttributedChats } from './components/Lists/TabAttributedChats';
import { TabChatsInAttendance } from './components/Lists/TabInChatsAttendance';
import {
  filterConversation,
  filterss
} from './components/Lists/helpers/filters';
import { addAnsweredConversation } from 'store/action/answered-conversations-action';
import { removeUnAnsweredConversation } from 'store/action/unanswered-convertations-action';
import { TabChatsInWait } from './components/Lists/TabChatsInWait';
import { removeConversationInAttendance } from 'store/action/conversation-in-attendance-action';
import { useQueueContentChatContext } from 'hooks/useQueueContentChat';
import ServiceCRUDChatTS from 'services/ServiceCRUDCHATTS';
import { saveObjectToLocalStorage } from 'utils/fuctions/localStorage';
import { LOCAL_STORAGE_KEYS } from 'utils/fuctions/localStorage';
import { verifyRoles } from 'components/Authentication/VerifyRoles';
import { alterContactNameOnConversation } from 'store/action/answered-conversations-action';
import { useQueueSyncHeartbeat } from 'hooks/useQueueSyncHeartbeat';

const pullChatService = new ServiceCRUDChatTS('/configurations/pull-chat');

export const TABS = {
  ATTRIBUTED: 'ATTRIBUTED',
  IN_ATTENDANCE: 'IN_ATTENDANCE',
  IN_WAIT: 'IN_WAIT'
};

/**
 * @typedef {Object} MinimalConversation
 * @property {string} _id
 * @property {string} id
 * @property {boolean} atendida
 * @property {string} situacao
 * @property {string} fila
 */

/**
 * @typedef {Object} FullConversation
 * @property {string} _id
 * @property {string} canal
 * @property {string} apelidoCanal
 * @property {boolean} status
 * @property {boolean} atendimentoBot
 * @property {string} situacao
 * @property {string} fila
 * @property {Client} cliente
 * @property {string} hora_criacao
 * @property {Attendant} atendente
 * @property {string} hora_do_atendimento
 * @property {boolean} isBroadCastList
 * @property {string} nameBroadCastList
 * @property {Array} tags
 */

/**
 * @typedef {Object} PullChatConfig
 * @property {boolean} active - Whether pull chat is active
 * @property {number} maxPullChat - Maximum number of chats that can be pulled
 */

/**
 * Hook to fetch and memoize pull chat configuration
 * @returns {PullChatConfig} The pull chat configuration
 */
const usePullChatConfig = () => {
  const [config, setConfig] = useState({ active: false, maxPullChat: 1 });

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const res = await pullChatService.get();
        const newConfig = res?.data ?? { active: false, maxPullChat: 1 };

        saveObjectToLocalStorage(
          LOCAL_STORAGE_KEYS.CONFIG_CHAT_MAX_PULL_CHAT,
          newConfig
        );

        setConfig(newConfig);
      } catch (error) {
        toast.error(
          'Não foi possível buscar o limite de resgate de conversas',
          {
            autoClose: 3000,
            closeOnClick: true
          }
        );
        console.error(error);
      }
    };

    fetchConfig();
  }, []);

  return config;
};

const QueueContent = () => {
  const {
    sort,
    setSort,
    filters,
    setFilters,
    chatsSaved,
    setAllChats,
    getAllQueuesChat,
    countChatsInWait,
    setCountChatsInWait,
    countAttributedChats,
    countChatsInAttendance,
    chatsWithResponseAgent,
    setCountAttributedChats,
    setCountChatsInAttendance,
    setCounterChatMetrics
  } = useQueueContentChatContext();
  const history = useHistory();
  const dispatch = useDispatch();

  const { queuesChatLoggedValues, currentQueueChatPause, inQueueChatPause } =
    useQueueChatPauseContext();
  const { socketConversation } = useConversationConnectionSocketForMonitoring();
  const { emitEventAnsweredChat, socketChatTS } = useSocketConversationChatTs();

  // Sincroniza a fila a cada 60 segundos, atualizando possíveis conversas não detectadas ou já encerradas
  useQueueSyncHeartbeat(socketConversation, socketChatTS);

  const newContactInfo = useSelector((state) => state.contactEvents);

  /** @type {{ conversations: MinimalConversation[] | FullConversation[] }} */
  const unAnsweredConversations = useSelector(
    (state) => state.unAnsweredConversation
  );

  /** @type {{ conversations: FullConversation[] }} */
  const answeredConversations = useSelector(
    (state) => state.answeredConversation
  );

  const systemConfiguration = useSelector((state) => state.systemConfiguration);
  const telephonyServicePanel = useSelector(
    (state) => state.telephonyServicePanel
  );

  const [chatsInAttendance, setChatsInAttendance] = useState(false);
  const [chatsInWait, setChatsInWait] = useState(false);
  const [chatsAssigned, setChatsAssigned] = useState(false);

  const [queues, setQueues] = useState([]);
  const [idNameTags, setIdNameTags] = useState({});
  const [tags, setTags] = useState([]);
  //const [allConversation, setAllConversation] = useState([]);
  const [activeTab, setActiveTab] = useState(TABS.IN_ATTENDANCE);
  const [search, setSearch] = useState('');

  const [selectedConversations, setSelectedConversations] = useState([]);
  const [currentOpenChatId, setCurrentOpenChatId] = useState(null); // ← NOVO ESTADO

  const [newContactInfoController, setNewContactInfoController] =
    useState(null);

  const maxPullChatConfig = usePullChatConfig();

  const answerConversationToast = (id) => {
    const chat = answeredConversations.conversations.find(
      (chat) => chat?.id === id
    );
    answerConversation(chat, id);
  };
  //Realizar ação ao clicar no card

  const idChatToast = useMemo(() => {
    return history?.location?.state;
  }, [history?.location?.state]);

  useEffect(() => {
    if (idChatToast?.idChat) {
      answerConversationToast(idChatToast?.idChat);
    }
  }, [idChatToast]);

  const handleCheck = useCallback(
    (event, id) => {
      if (event.target.checked) {
        setSelectedConversations((prev) => [...prev, id]);
        return;
      }
      const copy = [...selectedConversations];
      const index = copy.findIndex((item) => item === id);
      copy.splice(index, 1);
      setSelectedConversations(copy);
    },
    [selectedConversations]
  );

  useEffect(() => {
    if (Object.keys(newContactInfo.contactInfo).length > 0) {
      setNewContactInfoController(newContactInfo.contactInfo);
    }
  }, [newContactInfo]);

  const orderByChatsSaved = useCallback((chats, chatsSaved) => {
    if (!chatsSaved || chatsSaved.size === 0) {
      return chats;
    }
    return chats.sort((a, b) => {
      if (chatsSaved?.has(a?.id)) {
        return -1;
      }
      if (chatsSaved?.has(b?.id)) {
        return 1;
      }
      return 0;
    });
  }, []);

  const orderByLastMessage = useCallback((chats) => {
    if (!chats || chats.length === 0) return [];
    return [...chats].sort((a, b) => {
      const lastMessageA = a.mensagens
        .filter((message) => message.cliente_ou_atendente === 'cliente')
        .pop();

      const lastMessageB = b.mensagens
        .filter((message) => message.cliente_ou_atendente === 'cliente')
        .pop();

      const dateA =
        new Date().getTime() -
        new Date(lastMessageA?.hora_da_mensagem || 0).getTime();
      const dateB =
        new Date().getTime() -
        new Date(lastMessageB?.hora_da_mensagem || 0).getTime();

      return dateA - dateB;
    });
  }, []);

  const getLastMessage = (messages) => {
    return messages?.find(
      (message) =>
        message?.actions?.action === 'default' ||
        message?.actions?.action === 'answer'
    );
  };

  const orderByMoreTimeInChat = useCallback((chats) => {
    const getLastMessageCustomer = (
      messages,
      index,
      lastMessage,
      isInitialSequence
    ) => {
      const nextMessage = messages[index];

      if (!nextMessage) return lastMessage;

      if (nextMessage.cliente_ou_atendente === 'cliente') {
        return getLastMessageCustomer(messages, index - 1, nextMessage, false);
      }

      if (nextMessage.cliente_ou_atendente === 'atendente') {
        if (isInitialSequence)
          return getLastMessageCustomer(messages, index - 1, nextMessage, true);
        else return lastMessage;
      }

      return null;
    };

    if (!chats || chats.length === 0) return [];

    return [...chats]
      .sort((a, b) => {
        const lastMessageA = getLastMessage(a?.mensagens);
        const lastMessageB = getLastMessage(b?.mensagens);

        // Verificar se a última mensagem é do atendente
        const isLastMessageFromAgentA =
          lastMessageA?.cliente_ou_atendente === 'atendente';
        const isLastMessageFromAgentB =
          lastMessageB?.cliente_ou_atendente === 'atendente';

        if (isLastMessageFromAgentA && !isLastMessageFromAgentB) return -1;

        if (!isLastMessageFromAgentA && isLastMessageFromAgentB) return 1;

        if (isLastMessageFromAgentA && isLastMessageFromAgentB) return 0;

        const lastClientMessageA = getLastMessageCustomer(
          a?.mensagens,
          a?.mensagens.length - 1,
          null,
          true
        );

        const lastClientMessageB = getLastMessageCustomer(
          b?.mensagens,
          b?.mensagens.length - 1,
          null,
          true
        );

        const dateA =
          new Date().getTime() -
          new Date(lastClientMessageA?.hora_da_mensagem || 0).getTime();
        const dateB =
          new Date().getTime() -
          new Date(lastClientMessageB?.hora_da_mensagem || 0).getTime();

        return dateB - dateA;
      })
      .reverse();
  }, []);

  const orderByMoreTimeInQueue = useCallback((chats) => {
    if (!chats || chats.length === 0) return [];
    return [...chats].sort((a, b) => {
      const dateA = new Date(a.hora_criacao).getTime();
      const dateB = new Date(b.hora_criacao).getTime();

      const dateNow = new Date().getTime();

      const differenceA = dateNow - dateA;
      const differenceB = dateNow - dateB;

      return differenceB - differenceA;
    });
  }, []);

  const organizedConversations = useCallback(
    (chats) => {
      let chatsOrder = chats;

      if (sort['CHATS_SAVED']) {
        return orderByChatsSaved(chatsOrder, chatsSaved);
      }

      if (sort['LAST_MESSAGE_CUSTOMER']) {
        return orderByLastMessage(chatsOrder);
      }

      if (sort['MORE_TIME_IN_WAIT']) {
        return orderByMoreTimeInChat(chatsOrder);
      }

      if (sort['MORE_TIME_IN_QUEUE']) {
        return orderByMoreTimeInQueue(chatsOrder);
      }
      return chatsOrder;
    },
    [
      sort,
      chatsSaved,
      orderByChatsSaved,
      orderByLastMessage,
      orderByMoreTimeInChat,
      orderByMoreTimeInQueue
    ]
  );

  /**
   * Determina qual visualização deve aparecer na tab "em espera"
   * Se o modo de limitação for "limitar por agente"
   *
   * 1 - O agente tem a role de ver o botão -> não salvar os chats em estado e mostrar apenas o total de chats
   *
   * 2 - O agente não tem a role de ver o botão -> salvar os chats em estado e mostrar o total + os cards dos chats
   */
  const shouldShowChatsInWait = useMemo(
    () => !(maxPullChatConfig.active && verifyRoles(['PULL_CHAT'])),
    [maxPullChatConfig.active, verifyRoles]
  );

  useEffect(() => {
    if (!newContactInfoController) return;

    const chatId = newContactInfoController?.conversationId;
    const newContactName = newContactInfoController?.contactName;

    dispatch(
      alterContactNameOnConversation({
        chatId,
        newContactName
      })
    );
  }, [answeredConversations, newContactInfoController]);

  useEffect(() => {
    getAllQueuesChat()
      .then((response) => {
        let arrayQueues = [];
        const attendantQueues = JSON.parse(localStorage.getItem('queues'));
        response.forEach((queue) => {
          attendantQueues.forEach((attendantQueue) => {
            if (queue.id === attendantQueue.id) arrayQueues.push(queue);
          });
        });

        setQueues(arrayQueues);
      })
      .catch((err) => {
        console.log('err', err);
      });

    TagClientService.getAll({ showDisabled: true }).then((response) => {
      const tagsResponse = response.data.data;

      if (tagsResponse && tagsResponse?.length) {
        const idToTagName = {};
        tagsResponse.forEach((tag) => {
          idToTagName[tag.id] = {
            name: tag.name,
            disabled: tag?.disabled,
            color: tag?.color
          };
        });

        setIdNameTags(idToTagName);
        setTags(tagsResponse);
      }
    });
  }, []);

  const getConversations = useCallback(() => {
    socketConversation.emit('conversas_do_atendente', {
      atendente_login: localStorage.getItem('login')
    });
  }, [socketConversation]);

  useEffect(() => {
    getConversations();
  }, [getConversations]);

  useSocketEvents(socketConversation, {
    conversa_atendida: async (data) => {
      if (data.ja_atendida === undefined || data.ja_atendida === false) {
        await store.dispatch(addInitConversationInAttendance(data.conversa));
        getConversations();
      } else {
        getConversations();
      }
    }
  });

  useSocketEvents(socketChatTS, {
    conversa_atendida: async (data) => {
      await store.dispatch(removeConversationInAttendance());
      await store.dispatch(addInitConversationInAttendance(data.conversa));
      await store.dispatch(addAnsweredConversation(data.conversa));
      await store.dispatch(
        removeUnAnsweredConversation(data.conversa._id ?? data.conversa.id)
      );

      setActiveTab(TABS.IN_ATTENDANCE);
    }
  });

  useSocketEvents(socketChatTS, {
    [EVENTS_EMIT.UPDATE_CONFIG_SIGNAL_CONVERSATION]: async (data) => {
      window.localStorage.setItem(
        'configSignalConversation',
        JSON.stringify(data)
      );
    }
  });

  const answerConversation = async (
    conversation,
    id,
    transferMode,
    clientPhone,
    canal = ''
  ) => {
    if (transferMode === 'call') {
      if (telephonyServicePanel.extension === '') {
        toast.error(
          `Você precisa estar logado em um ramal para continuar este atendimento!`,
          {
            autoClose: 3000,
            closeOnClick: true
          }
        );
        return;
      }

      if (clientPhone === '') {
        toast.error(
          `Não é possível realizar a chamada pois não há telefone no cadastro do cliente!`,
          {
            autoClose: 3000,
            closeOnClick: true
          }
        );
        return;
      }

      if (
        !window.confirm(
          'Este cliente deseja um atendimento por ligação, tem certeza que deseja realizar a chamada agora?'
        )
      )
        return;

      const data = {
        origem: telephonyServicePanel.extension,
        destino: clientPhone
      };

      await apiChat.post(`/clicktocall`, data);
    }

    if (conversation?.situacao === ChatSituations.WAITING_IN_QUEUE) {
      return;
    }

    if (
      !conversation?.atendida &&
      conversation?.atendente?.id_postgres &&
      queuesChatLoggedValues?.length === 0
    ) {
      await store.dispatch(addInitConversationInAttendance(conversation));

      return;
    }

    if (
      inQueueChatPause &&
      currentQueueChatPause &&
      !currentQueueChatPause.active
    ) {
      await store.dispatch(addInitConversationInAttendance(conversation));
      return;
    }

    try {
      await emitEventAnsweredChat({
        chatId: id,
        socketId:
          canal === 'facebook' || canal === 'telegram'
            ? socketConversation.id
            : socketChatTS.id
      });
    } catch (error) {
      toast.error(error?.message ?? 'Não foi possível atender a conversa.', {
        autoClose: 3000,
        closeOnClick: true
      });
      console.error(error);
    }
  };

  const handlerFilter = useCallback(
    (option, type) => {
      const filtersCopy = { ...filters };
      const typesBoolean = [
        'CHATS_SAVED',
        'INTERACTION_AGENT_WARNING',
        'INTERACTION_AGENT_CRITICAL',
        'INTERACTION_CLIENT',
        'CHATS_WITH_RESPONSE_AGENT'
      ];

      if (option === 'ALL') {
        filtersCopy[type] = [];
        setFilters(filtersCopy);
        return;
      }

      if (type === 'TIME') {
        filtersCopy[type] = option;
        setFilters(filtersCopy);
        return;
      }

      if (type === 'STATUS') {
        if (!Array.isArray(filtersCopy[type])) filtersCopy[type] = [];
        const index = filtersCopy[type].indexOf(option);
        if (option === 'ALL') {
          filtersCopy[type] = [];
        } else if (index > -1) {
          filtersCopy[type].splice(index, 1);
        } else {
          filtersCopy[type].push(option);
        }
        setFilters(filtersCopy);
        return;
      }
      if (type === 'START_TYPE') {
        if (option === filtersCopy[type]) {
          filtersCopy[type] = [];
          setFilters(filtersCopy);
          return;
        }
        filtersCopy[type] = option;
        setFilters(filtersCopy);
        return;
      }

      if (typesBoolean.includes(type)) {
        filtersCopy[type] = !filtersCopy[type];
        setFilters(filtersCopy);
        return;
      }

      const data = filtersCopy[type];
      if (!data) return;
      const index = data?.indexOf(option);
      if (index > -1) {
        data.splice(index, 1);
      } else {
        data.push(option);
      }
      filtersCopy[type] = queues;
      setFilters(filtersCopy);
    },
    [filters, queues]
  );

  const handlerSort = useCallback(
    (type) => {
      const sortCopy = { ...sort };
      Object.keys(sortCopy).forEach((key) => {
        if (key === type) {
          sortCopy[key] = !sortCopy[type];
        }
        if (key !== type) {
          sortCopy[key] = false;
        }
      });
      setSort(sortCopy);
    },
    [sort]
  );

  const counterChatMetrics = useCallback((chats) => {
    const counters = {
      agentCritical: 0,
      agentWarning: 0,
      withAgentResponse: 0,
      customerCritical: 0
    };

    chats.forEach((chat) => {
      if (chat?.statusOfChat === 'AgentCritical') {
        counters.agentCritical += 1;
      }
      if (chat?.statusOfChat == 'AgentWarning') {
        counters.agentWarning += 1;
      }
      if (chat?.withResponseAgent) {
        counters.withAgentResponse += 1;
      }
      if (chat?.statusOfChat === 'CustomerCritical') {
        counters.customerCritical += 1;
      }
    });

    setCounterChatMetrics(counters);
  }, []);

  const getAgentLogged = useCallback(() => {
    return localStorage.getItem('login');
  }, []);

  useEffect(() => {
    const isInAttendance = (chat) => {
      return (
        chat?.atendida && chat?.atendente?.id_postgres === getAgentLogged()
      );
    };

    const isAttributed = (chat) => {
      return (
        !chat?.atendida && chat?.atendente?.id_postgres === getAgentLogged()
      );
    };

    const shouldFilter =
      filters['FILA'].length ||
      filters['TAG'].length ||
      filters['STATUS'].length ||
      filters['TIME'].length ||
      filters['START_TYPE'].length ||
      filters['CHATS_SAVED'] ||
      filters['INTERACTION_AGENT_WARNING'] ||
      filters['INTERACTION_AGENT_CRITICAL'] ||
      filters['INTERACTION_CLIENT'] ||
      filters['CHATS_WITH_RESPONSE_AGENT'];

    const response = {
      IN_ATTENDANCE: [],
      ATTRIBUTED: [],
      IN_WAIT: [
        ...new Map(
          unAnsweredConversations.conversations.map((item) => [item.id, item])
        ).values()
      ]
    };

    answeredConversations.conversations.forEach((chat) => {
      if (isInAttendance(chat)) {
        response.IN_ATTENDANCE.unshift(chat);
      } else if (isAttributed(chat)) {
        response.ATTRIBUTED.unshift(chat);
      }
    });

    const filterInternalConversation = (chats = []) => {
      const chatsComStatus = chats.map((conversation) => {
        const mensagens = conversation?.mensagens ?? [];
        const ultimaMensagem = getUltimaMensagemDefault(mensagens);
        let statusDinamico = ChatSituations.IN_ATTENDANCE;
        if (ultimaMensagem) {
          const escritaPor = ultimaMensagem?.cliente_ou_atendente;
          if (escritaPor === 'atendente') {
            statusDinamico = ChatSituations.WAITING_FOR_ANSWER;
          }
        }

        return {
          ...conversation,
          status: statusDinamico
        };
      });

      let internalChats = chatsComStatus;
      if (shouldFilter) {
        internalChats = internalChats.filter((chat) => {
          return filterss(chat, filters, search, chatsSaved);
        });
      }

      if (search && search !== '' && search?.length) {
        internalChats = internalChats.filter((chat) =>
          filterConversation(chat, search)
        );
      }
      return internalChats;
    };

    setChatsInAttendance(() => {
      const result = organizedConversations(
        filterInternalConversation(response.IN_ATTENDANCE)
      );
      setCountChatsInAttendance(result.length);
      counterChatMetrics(result);

      return result;
    });

    setChatsAssigned(() => {
      const result = organizedConversations(
        filterInternalConversation(response.ATTRIBUTED)
      );
      setCountAttributedChats(result.length);
      return result;
    });

    // Deve mostrar os cards das conversas completos
    if (shouldShowChatsInWait) {
      setChatsInWait(() => {
        const result = organizedConversations(
          filterInternalConversation(response.IN_WAIT)
        );
        setCountChatsInWait(result.length);

        return result;
      });
    } else {
      // Não deve mostrar os cards, apenas a quantidade
      setCountChatsInWait(response?.IN_WAIT?.length ?? 0);
    }

    const allChats = [
      ...response.IN_ATTENDANCE,
      ...response.ATTRIBUTED,
      ...response.IN_WAIT
    ];

    if (
      answeredConversations.conversations?.length ||
      unAnsweredConversations.conversations?.length
    ) {
      setAllChats(allChats);
    }
  }, [
    answeredConversations.conversations,
    unAnsweredConversations.conversations,
    search,
    filters,
    chatsSaved,
    sort,
    chatsSaved,
    chatsWithResponseAgent,
    maxPullChatConfig.active
  ]);

  function getUltimaMensagemDefault(mensagens = []) {
    const mensagensDefault = mensagens.filter(
      (msg) => msg.actions?.action === 'default'
    );
    return mensagensDefault[mensagensDefault.length - 1];
  }

  useEffect(() => {
    const interval = setInterval(() => {
      dispatch(checkAndLogout());
    }, 60000);

    return () => clearInterval(interval);
  }, [dispatch]);

  return (
    <Content primaryColor={systemConfiguration.primary_color}>
      <Header>
        <IndividualActiveContact
          getConversations={getConversations}
          selectedChats={selectedConversations}
          setSelectedChats={setSelectedConversations}
        />
        <SearchChat
          tags={tags}
          search={search}
          setSearch={setSearch}
          handlerFilter={handlerFilter}
          handlerSort={handlerSort}
        />
        <FilterBar handlerFilter={handlerFilter} />
        <TabChats
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          countAttributedChats={countAttributedChats}
          countChatsInWait={countChatsInWait}
          countChatsInAttendance={countChatsInAttendance}
        />
      </Header>

      <TabContent activeTab={activeTab}>
        <TabChatsInWait
          queues={queues}
          idNameTags={idNameTags}
          chats={chatsInWait}
          answerConversation={answerConversation}
          currentOpenChatId={currentOpenChatId}
        />

        <TabAttributedChats
          queues={queues}
          idNameTags={idNameTags}
          chats={chatsAssigned}
          answerConversation={answerConversation}
          currentOpenChatId={currentOpenChatId}
        />

        <TabChatsInAttendance
          queues={queues}
          idNameTags={idNameTags}
          handleCheck={handleCheck}
          chats={chatsInAttendance}
          answerConversation={answerConversation}
          selectedConversations={selectedConversations}
          currentOpenChatId={currentOpenChatId}
        />
      </TabContent>
    </Content>
  );
};

export default QueueContent;
